module.exports = __webpack_public_path__ + "media/customizations/womensleadership/logo-new-2477694ec4413b7ec8f26dfd17194bb5.png";